import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import CssBaseline from '@mui/material/CssBaseline';
import FormControlLabel from '@mui/material/FormControlLabel';
import Divider from '@mui/material/Divider';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import Link from '@mui/material/Link';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import MuiCard from '@mui/material/Card';
import { styled } from '@mui/material/styles';
import ForgotPassword from './components/ForgotPassword';
import AppTheme from '../../Componenets/shared-theme/AppTheme';
import ColorModeSelect from '../../Componenets/shared-theme/ColorModeSelect';
import { GoogleIcon, FacebookIcon, SitemarkIcon } from './components/CustomIcons';
import {navigate, useNavigate}  from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import { loginUser, signupUser , clearError } from '../../Redux/Auth/AuthSlice';
import Loader from '../../Componenets/Loader'
import Swal from 'sweetalert2'
import { sendOtp, verifyOtp, resetOtpState , clearError as clearOtpError , resetOtp} from '../../Redux/Otp/otpSlice';
import {useState , useEffect} from 'react'
import UpdatePasswordComp from './components/UpdatePassword'
import {updatePassword} from '../../Redux/User/userSlice';
import toast, { Toaster } from 'react-hot-toast';
import {addToCart_db} from '../../Redux/db_Cart/db_cartSlice'



const Card = styled(MuiCard)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'center',
  width: '100%',
  padding: theme.spacing(4),
  gap: theme.spacing(2),
  margin: 'auto',
  [theme.breakpoints.up('sm')]: {
    maxWidth: '450px',
  },
  boxShadow:
    'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
  ...theme.applyStyles('dark', {
    boxShadow:
      'hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px',
  }),
}));

const SignInContainer = styled(Stack)(({ theme }) => ({
  height: 'calc((1 - var(--template-frame-height, 0)) * 100dvh)',
  minHeight: '100%',
  padding: theme.spacing(2),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(4),
  },
  '&::before': {
    content: '""',
    display: 'block',
    position: 'absolute',
    zIndex: -1,
    inset: 0,
    backgroundImage:
      'radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))',
    backgroundRepeat: 'no-repeat',
    ...theme.applyStyles('dark', {
      backgroundImage:
        'radial-gradient(at 50% 50%, hsla(210, 100%, 16%, 0.5), hsl(220, 30%, 5%))',
    }),
  },
}));

export default function SignIn(props) {
  const [emailError, setEmailError] = React.useState(false);
  const [emailErrorMessage, setEmailErrorMessage] = React.useState('');
  const [passwordError, setPasswordError] = React.useState(false);
  const [passwordErrorMessage, setPasswordErrorMessage] = React.useState('');
  const [open, setOpen] = React.useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [otp , setOtp] = useState('')
  const { loading, error } = useSelector((state) => state.auth);
  const [fpEmail , setFpEmail] = useState('');
  const { loading:otpLoading, otpSent, verified, error:otpError } = useSelector((state) => state.otp);
  const [updatePasswordOpen , setUpdatePasswordOpen] = useState(false);
  const [passwordToUpdate , setPasswordToUpdate] = useState("")
  const {user , loading : updatingPassword , error:updatingError} = useSelector((state)=> state.user)
  const handleSendOtp = (email)=>{
    dispatch(sendOtp(email));
  }

  const handleVerifyOtp = (email)=>{
    try {
      dispatch(verifyOtp({email , otp}));
    } catch (error) {
      console.log(error)
    }

  }

  useEffect(()=>{
    if(otpError){
      toast.error("Invalid or expired otp!");
    }
  } , [otpError])
 

  useEffect(()=>{
    if(verified){
      setUpdatePasswordOpen(true);
      handleClickOpen(false);
      toast.success("OTP verified!");

    }
  } , [verified]);

  const handleUpdatePassword = () => {
    console.log("FpEmail", fpEmail);
    console.log("passwordToUpdate", passwordToUpdate);
    if(passwordToUpdate.length <6){
      alert("Password length must be at least 6")
      return
    }
  
    if (!fpEmail || !passwordToUpdate) {
      alert("Email and password are required");
      return;
    }
    
    try {
      dispatch(updatePassword({ email: fpEmail, updatedData: { password: passwordToUpdate } }));
      toast.success("Password updated!");
      handleUpdatePasswordClose()
      handleClose()
      } catch (error) {
      alert('Error occurred while updating profile' , error.message)
  }
  
    
  };
  if(error){
    Swal.fire({
      position: "top-end",
      icon: "error",
      title: "Sign in Failed: "+ error,
      showConfirmButton: false,
      timer: 1500
    });
    dispatch(clearError());
}
  const handleClickOpen = () => {
    setOpen(true);
  };
  
  const handleClose = () => {
    setOpen(false);
    dispatch(resetOtp())
  };

  const handleUpdatePasswordOpen = () => {
    setUpdatePasswordOpen(true);
  };
  
  const handleUpdatePasswordClose = () => {
    setUpdatePasswordOpen(false);
    // dispatch(resetOtp())
  };

  const loadCartFromLocalStorage = () => {
    const cart = localStorage.getItem("cart");
    return cart ? JSON.parse(cart) : [];
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (emailError || passwordError) {
      event.preventDefault();
      return;
    }
    const data = new FormData(event.currentTarget);
    try{
       await dispatch(loginUser({
            email: data.get('email'),
            password: data.get('password'),
          })).unwrap();
          navigate('/')
    }catch(err){
        console.log(err)
    }

    let cartItems = loadCartFromLocalStorage();
    if(cartItems.length > 0){
      cartItems.forEach((item)=>{
        dispatch(addToCart_db({productId : item?.id, quantity : item?.quantity}))
      })
      localStorage.removeItem("cart")
    }
 
  };
  console.log("loading" , loading)

  const validateInputs = () => {
    const email = document.getElementById('email');
    const password = document.getElementById('password');

    let isValid = true;

    if (!email.value || !/\S+@\S+\.\S+/.test(email.value)) {
      setEmailError(true);
      setEmailErrorMessage('Please enter a valid email address.');
      isValid = false;
    } else {
      setEmailError(false);
      setEmailErrorMessage('');
    }

    if (!password.value || password.value.length < 6) {
      setPasswordError(true);
      setPasswordErrorMessage('Password must be at least 6 characters long.');
      isValid = false;
    } else {
      setPasswordError(false);
      setPasswordErrorMessage('');
    }

    return isValid;
  };

  return (
    <AppTheme {...props}>
      <CssBaseline enableColorScheme />
      <SignInContainer direction="column" justifyContent="space-between">
        <Toaster />
        {(loading || otpLoading || updatingPassword) && <Loader />}
        {/* <ColorModeSelect sx={{ position: 'fixed', top: '1rem', right: '1rem' }} /> */}
        {/* <Button onClick={()=>navigate('/')} sx={{width : '10%'}} variant="contained" color="primary">
            Go to Home
          </Button> */}

        <Card variant="outlined">
          {/* <SitemarkIcon /> */}
          {/* <Typography>Nature</Typography> */}
          <Typography
            component="h1"
            variant="h4"
            sx={{ width: '100%', fontSize: 'clamp(2rem, 10vw, 2.15rem)' }}
          >
            Sign in
          </Typography>
          <Box
            component="form"
            onSubmit={handleSubmit}
            noValidate
            sx={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              gap: 2,
            }}
          >
            <FormControl>
              <FormLabel htmlFor="email">Email</FormLabel>
              <TextField
                error={emailError}
                helperText={emailErrorMessage}
                id="email"
                type="email"
                name="email"
                placeholder="your@email.com"
                autoComplete="email"
                autoFocus
                required
                fullWidth
                variant="outlined"
                color={emailError ? 'error' : 'primary'}
              />
            </FormControl>
            <FormControl>
              <FormLabel htmlFor="password">Password</FormLabel>
              <TextField
                error={passwordError}
                helperText={passwordErrorMessage}
                name="password"
                placeholder="••••••"
                type="password"
                id="password"
                autoComplete="current-password"
                autoFocus
                required
                fullWidth
                variant="outlined"
                color={passwordError ? 'error' : 'primary'}
              />
            </FormControl>
           
            <ForgotPassword email={fpEmail} setEmail={setFpEmail} verifyOtp={handleVerifyOtp} handleSendOtp={handleSendOtp} otpSent={otpSent} otp={otp} setOtp={setOtp}  open={open} handleClose={handleClose} />
            <UpdatePasswordComp handleUpdatePassword={handleUpdatePassword} setPasswordToUpdate={setPasswordToUpdate} open={updatePasswordOpen} handleClose={handleUpdatePasswordClose} />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              onClick={validateInputs}
            >
              Sign in
            </Button>
            <Link
              component="button"
              type="button"
              onClick={handleClickOpen}
              variant="body2"
              sx={{ alignSelf: 'center' }}
            >
              Forgot your password?
            </Link>
          </Box>
          {/* <Divider>or</Divider> */}
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {/* <Button
              fullWidth
              variant="outlined"
              onClick={() => alert('Sign in with Google')}
              startIcon={<GoogleIcon />}
            >
              Sign in with Google
            </Button> */}
            {/* <Button
              fullWidth
              variant="outlined"
              onClick={() => alert('Sign in with Facebook')}
              startIcon={<FacebookIcon />}
            >
              Sign in with Facebook
            </Button> */}
            <Typography sx={{ textAlign: 'center' }}>
              Don&apos;t have an account?{' '}
              <Link
                variant="body2"
                sx={{ alignSelf: 'center' , cursor : 'pointer' }}
                onClick={()=>navigate("/signup")}
              >
                Sign Up
              </Link>
            </Typography>
          </Box>
        </Card>
      </SignInContainer>
    </AppTheme>
  );
}